import React from 'react';
import { Head } from '../../foundation/Head/index.js';
import { TitleSeo } from './TitleSeo.client.js';
import { DescriptionSeo } from './DescriptionSeo.client.js';
export function HomePageSeo({ title, description, url, titleTemplate, }) {
    const organizationSchema = {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: title,
        url,
    };
    const webSiteSchema = {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        name: title,
        url,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Head, { defaultTitle: title ?? '', titleTemplate: titleTemplate ?? `%s` },
            React.createElement("meta", { property: "og:url", content: url }),
            React.createElement("script", { type: "application/ld+json" }, JSON.stringify(organizationSchema)),
            React.createElement("script", { type: "application/ld+json" }, JSON.stringify(webSiteSchema))),
        React.createElement(TitleSeo, { title: title }),
        description && React.createElement(DescriptionSeo, { description: description })));
}
